"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompliance = exports.complianceOptions = void 0;
const theme_1 = require("../../theme");
const intensity_low_png_1 = __importDefault(require("../../../images/intensity-low.png"));
const intensity_medium_png_1 = __importDefault(require("../../../images/intensity-medium.png"));
const intensity_high_png_1 = __importDefault(require("../../../images/intensity-high.png"));
exports.complianceOptions = {
    neutral: {
        color: theme_1.theme.colors.blue,
        text: "Compliant",
        icon: intensity_medium_png_1.default,
    },
    overcompliant: {
        color: theme_1.theme.colors.green,
        text: "Overcompliant",
        icon: intensity_low_png_1.default,
    },
    "not compliant": {
        color: theme_1.theme.colors.black,
        text: "Not compliant",
        icon: intensity_high_png_1.default,
    },
};
const getCompliance = (balance) => {
    if (balance === undefined) {
        return "neutral";
    }
    if (balance < 0) {
        return "not compliant";
    }
    if (balance < 1) {
        return "neutral";
    }
    return "overcompliant";
};
exports.getCompliance = getCompliance;
